import React from 'react';
import { SelectMenu } from '@scale/scaleui';

interface TimePickerProps {
  label: string;
  time: string;
  setTime: (time: string) => void;
  error?: boolean;
  disabled?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  label,
  time,
  setTime,
  error,
  disabled,
}) => {
  return (
    <SelectMenu
      label={label}
      options={TimeOptions}
      selectedOptionId={time}
      setSelected={id => setTime(id)}
      error={error}
      disabled={disabled}
    />
  );
};

export const TimeOptions = [
  {
    id: '12:00AM',
    name: '12:00AM',
  },
  {
    id: '12:15AM',
    name: '12:15AM',
  },
  {
    id: '12:30AM',
    name: '12:30AM',
  },
  {
    id: '12:45AM',
    name: '12:45AM',
  },
  {
    id: '01:00AM',
    name: '01:00AM',
  },
  {
    id: '01:15AM',
    name: '01:15AM',
  },
  {
    id: '01:30AM',
    name: '01:30AM',
  },
  {
    id: '01:45AM',
    name: '01:45AM',
  },
  {
    id: '02:00AM',
    name: '02:00AM',
  },
  {
    id: '02:15AM',
    name: '02:15AM',
  },
  {
    id: '02:30AM',
    name: '02:30AM',
  },
  {
    id: '02:45AM',
    name: '02:45AM',
  },
  {
    id: '03:00AM',
    name: '03:00AM',
  },
  {
    id: '03:15AM',
    name: '03:15AM',
  },
  {
    id: '03:30AM',
    name: '03:30AM',
  },
  {
    id: '03:45AM',
    name: '03:45AM',
  },
  {
    id: '04:00AM',
    name: '04:00AM',
  },
  {
    id: '04:15AM',
    name: '04:15AM',
  },
  {
    id: '04:30AM',
    name: '04:30AM',
  },
  {
    id: '04:45AM',
    name: '04:45AM',
  },
  {
    id: '05:00AM',
    name: '05:00AM',
  },
  {
    id: '05:15AM',
    name: '05:15AM',
  },
  {
    id: '05:30AM',
    name: '05:30AM',
  },
  {
    id: '05:45AM',
    name: '05:45AM',
  },
  {
    id: '06:00AM',
    name: '06:00AM',
  },
  {
    id: '06:15AM',
    name: '06:15AM',
  },
  {
    id: '06:30AM',
    name: '06:30AM',
  },
  {
    id: '06:45AM',
    name: '06:45AM',
  },
  {
    id: '07:00AM',
    name: '07:00AM',
  },
  {
    id: '07:15AM',
    name: '07:15AM',
  },
  {
    id: '07:30AM',
    name: '07:30AM',
  },
  {
    id: '07:45AM',
    name: '07:45AM',
  },
  {
    id: '08:00AM',
    name: '08:00AM',
  },
  {
    id: '08:15AM',
    name: '08:15AM',
  },
  {
    id: '08:30AM',
    name: '08:30AM',
  },
  {
    id: '08:45AM',
    name: '08:45AM',
  },
  {
    id: '09:00AM',
    name: '09:00AM',
  },
  {
    id: '09:15AM',
    name: '09:15AM',
  },
  {
    id: '09:30AM',
    name: '09:30AM',
  },
  {
    id: '09:45AM',
    name: '09:45AM',
  },
  {
    id: '10:00AM',
    name: '10:00AM',
  },
  {
    id: '10:15AM',
    name: '10:15AM',
  },
  {
    id: '10:30AM',
    name: '10:30AM',
  },
  {
    id: '10:45AM',
    name: '10:45AM',
  },
  {
    id: '11:00AM',
    name: '11:00AM',
  },
  {
    id: '11:15AM',
    name: '11:15AM',
  },
  {
    id: '11:30AM',
    name: '11:30AM',
  },
  {
    id: '11:45AM',
    name: '11:45AM',
  },
  {
    id: '12:00PM',
    name: '12:00PM',
  },
  {
    id: '12:15PM',
    name: '12:15PM',
  },
  {
    id: '12:30PM',
    name: '12:30PM',
  },
  {
    id: '12:45PM',
    name: '12:45PM',
  },
  {
    id: '01:00PM',
    name: '01:00PM',
  },
  {
    id: '01:15PM',
    name: '01:15PM',
  },
  {
    id: '01:30PM',
    name: '01:30PM',
  },
  {
    id: '01:45PM',
    name: '01:45PM',
  },
  {
    id: '02:00PM',
    name: '02:00PM',
  },
  {
    id: '02:15PM',
    name: '02:15PM',
  },
  {
    id: '02:30PM',
    name: '02:30PM',
  },
  {
    id: '02:45PM',
    name: '02:45PM',
  },
  {
    id: '03:00PM',
    name: '03:00PM',
  },
  {
    id: '03:15PM',
    name: '03:15PM',
  },
  {
    id: '03:30PM',
    name: '03:30PM',
  },
  {
    id: '03:45PM',
    name: '03:45PM',
  },
  {
    id: '04:00PM',
    name: '04:00PM',
  },
  {
    id: '04:15PM',
    name: '04:15PM',
  },
  {
    id: '04:30PM',
    name: '04:30PM',
  },
  {
    id: '04:45PM',
    name: '04:45PM',
  },
  {
    id: '05:00PM',
    name: '05:00PM',
  },
  {
    id: '05:15PM',
    name: '05:15PM',
  },
  {
    id: '05:30PM',
    name: '05:30PM',
  },
  {
    id: '05:45PM',
    name: '05:45PM',
  },
  {
    id: '06:00PM',
    name: '06:00PM',
  },
  {
    id: '06:15PM',
    name: '06:15PM',
  },
  {
    id: '06:30PM',
    name: '06:30PM',
  },
  {
    id: '06:45PM',
    name: '06:45PM',
  },
  {
    id: '07:00PM',
    name: '07:00PM',
  },
  {
    id: '07:15PM',
    name: '07:15PM',
  },
  {
    id: '07:30PM',
    name: '07:30PM',
  },
  {
    id: '07:45PM',
    name: '07:45PM',
  },
  {
    id: '08:00PM',
    name: '08:00PM',
  },
  {
    id: '08:15PM',
    name: '08:15PM',
  },
  {
    id: '08:30PM',
    name: '08:30PM',
  },
  {
    id: '08:45PM',
    name: '08:45PM',
  },
  {
    id: '09:00PM',
    name: '09:00PM',
  },
  {
    id: '09:15PM',
    name: '09:15PM',
  },
  {
    id: '09:30PM',
    name: '09:30PM',
  },
  {
    id: '09:45PM',
    name: '09:45PM',
  },
  {
    id: '10:00PM',
    name: '10:00PM',
  },
  {
    id: '10:15PM',
    name: '10:15PM',
  },
  {
    id: '10:30PM',
    name: '10:30PM',
  },
  {
    id: '10:45PM',
    name: '10:45PM',
  },
  {
    id: '11:00PM',
    name: '11:00PM',
  },
  {
    id: '11:15PM',
    name: '11:15PM',
  },
  {
    id: '11:30PM',
    name: '11:30PM',
  },
  {
    id: '11:45PM',
    name: '11:45PM',
  },
];
